// helpers
import set from 'lodash/set'
import some from 'lodash/some'
import every from 'lodash/every'
import axiosRequest from 'utils/axiosRequest'

const { REACT_APP_NAME: APP_NAME, REACT_APP_AUTH_URL: authUrl } = process.env

const logoutAuth = async authToken => {
  axiosRequest({
    url: '/user/logout',
    method: 'POST',
    baseURL: authUrl,
    headers: {
      Authorization: `Bearer ${authToken}`
    }
  })
}

const handler = {
  set: function (obj, prop, value) {
    authService.observers.forEach(ob => ob({ ...obj, [prop]: value }))
    set(obj, prop, value)
    return true
  }
}

const authService = {
  state: new Proxy(
    {
      getting: false,
      name: null,
      authToken: null,
      token: null,
      clientId: null,
      username: null,
      roles: null,
      displayed: false
    },
    handler
  ),

  observers: [],

  verifyCredentials: function () {
    const rawStore = window.localStorage.getItem(APP_NAME) ?? '{"token":null, "email": null}'
    let store = {} as any
    try {
      store = JSON.parse(rawStore)
    } catch (e) {
      store = { token: null }
    }

    if (store.token) {
      this.state.authToken = store.token
      this.state.username = store.email
      this.state.getting = true
    }
  },
  subscribe: function (observer) {
    this.observers.push(observer)
  },
  setGetting(val) {
    this.state.getting = val
  },
  setToken(val) {
    this.state.token = val
  },
  logout(reload = true) {
    logoutAuth(this.state.authToken)

    this.state.token = null
    this.state.name = null
    this.state.username = null
    this.state.authToken = null

    window.localStorage.removeItem(APP_NAME)

    if (reload) document.location.reload()
  },
  setAuthLogin(authToken, username) {
    this.state.authToken = authToken
    this.state.username = username
    this.state.getting = true

    const store = { token: authToken, email: username }
    window.localStorage.setItem(APP_NAME, JSON.stringify(store))
  },
  setLogin(token, name, clientId, roles) {
    this.state.token = token
    this.state.name = name
    this.state.clientId = clientId
    this.state.getting = false
    this.state.roles = roles
  },
  setDisplayed(displayed = false) {
    this.state.displayed = displayed
  },
  hasRole(roles = []) {
    const userRoles = this.state.roles
    console.log(userRoles)
    return some(roles, (rol) => userRoles.includes(rol))
  },
  hasOnlyRoles(roles = []) {
    const userRoles = this.state.roles
    if (userRoles?.length !== roles.length) return false

    return every(roles, (rol) => userRoles.includes(rol))
  }
}

export default authService
